import { t } from 'i18next'

import * as yup from 'yup'

import { IFormModel } from 'types'

/**
 * Form constants
 */
const TITLE = 'title'
const GROUP_COURSE = 'group_course'

/**
 * Form model
 */
const formModel = (): IFormModel => {
  return {
    [TITLE]: {
      label: `${t('common.title')}`,
      name: TITLE,
      required: true,
    },
    [GROUP_COURSE]: {
      label: `${t('common.group-course')}`,
      name: GROUP_COURSE,
      required: true,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [TITLE]: '',
  [GROUP_COURSE]: null,

}

/**
 * Form data validation
 */
export const validationSchema = () =>
  yup.object().shape({
    [TITLE]: yup
      .string()
      .required(`${t('errors.required-error-message')}`),
    [GROUP_COURSE]: yup
      .object()
      .required(`${t('errors.required-error-message')}`)
      .typeError('errors.invalid-date-message'),
  })

export default formModel
